export const SCROLLBAR_THIN_CLASS_NAME = [
  "tw:[scrollbar-width:thin]",
  "tw:[scrollbar-color:color-mix(in_srgb,var(--line-strong)_65%,transparent)_transparent]",
  "tw:[&::-webkit-scrollbar]:h-[9px]",
  "tw:[&::-webkit-scrollbar]:w-[9px]",
  "tw:[&::-webkit-scrollbar-thumb]:rounded-pill",
  "tw:[&::-webkit-scrollbar-thumb]:border-2",
  "tw:[&::-webkit-scrollbar-thumb]:border-transparent",
  "tw:[&::-webkit-scrollbar-thumb]:bg-[color-mix(in_srgb,var(--line-strong)_65%,transparent)]",
  "tw:[&::-webkit-scrollbar-thumb]:bg-clip-content",
].join(" ");
